// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Signup.css */
.base-signup {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #303030; /* Background color for the entire page */
    padding: 20px;
}

.signup-container {
    background-color: white; /* White background for the container */
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 300px;
}

.signup-container h2 {
    color: #333333; /* Dark text color for visibility */
    text-align: center;
    margin-bottom: 30px;
    font-size: 24px;
}

.signup-form .form-group {
    margin-bottom: 20px;
}

.signup-form label {
    display: block;
    color: #333333; /* Dark text color for labels */
    margin-bottom: 8px;
    font-size: 14px;
}

.signup-form input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc; /* Light border for input fields */
    border-radius: 5px;
    background-color: #f9f9f9; /* Light background for input fields */
    color: #333333; /* Dark text color for input fields */
    font-size: 14px;
    transition: border-color 0.3s ease;
}

.signup-form input:focus {
    outline: none;
    border-color: #007bff; /* Border color on focus */
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.signup-button {
    margin-top: 50px;
    width: 100%;
    padding: 12px;
    background-color: #007bff; /* Button color */
    color: #FFFFFF; /* White text color for button */
    border: none;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.signup-button:hover {
    background-color: #0056b3; /* Darker button color on hover */
}

.signup-button:disabled {
    background-color: #004085; /* Disabled button color */
    cursor: not-allowed;
}

.error {
    color: #dc3545; /* Error message color */
    font-size: 14px;
    margin-bottom: 15px;
    text-align: center;
}

.auth-switch {
    text-align: center;
    margin-top: 20px;
    color: #333333; /* Dark text color for switch link */
}

.auth-switch span {
    color: #007bff; /* Link color */
    cursor: pointer;
    margin-left: 5px;
    text-decoration: underline;
}

.auth-switch span:hover {
    color: #0056b3; /* Darker link color on hover */
}

/* Responsive Design */
@media (max-width: 480px) {
    .signup-container {
        padding: 25px;
    }
    
    .signup-container h2 {
        font-size: 22px;
    }
    
    .signup-form input {
        padding: 10px;
    }
    
    .signup-button {
        padding: 10px;
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Signup.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB,EAAE,yCAAyC;IACpE,aAAa;AACjB;;AAEA;IACI,uBAAuB,EAAE,uCAAuC;IAChE,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc,EAAE,mCAAmC;IACnD,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc,EAAE,+BAA+B;IAC/C,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB,EAAE,kCAAkC;IAC1D,kBAAkB;IAClB,yBAAyB,EAAE,sCAAsC;IACjE,cAAc,EAAE,qCAAqC;IACrD,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,qBAAqB,EAAE,0BAA0B;IACjD,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,yBAAyB,EAAE,iBAAiB;IAC5C,cAAc,EAAE,gCAAgC;IAChD,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB,EAAE,iCAAiC;AAChE;;AAEA;IACI,yBAAyB,EAAE,0BAA0B;IACrD,mBAAmB;AACvB;;AAEA;IACI,cAAc,EAAE,wBAAwB;IACxC,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc,EAAE,oCAAoC;AACxD;;AAEA;IACI,cAAc,EAAE,eAAe;IAC/B,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,cAAc,EAAE,+BAA+B;AACnD;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;AACJ","sourcesContent":["/* Signup.css */\n.base-signup {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    background-color: #303030; /* Background color for the entire page */\n    padding: 20px;\n}\n\n.signup-container {\n    background-color: white; /* White background for the container */\n    padding: 40px;\n    border-radius: 10px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 300px;\n}\n\n.signup-container h2 {\n    color: #333333; /* Dark text color for visibility */\n    text-align: center;\n    margin-bottom: 30px;\n    font-size: 24px;\n}\n\n.signup-form .form-group {\n    margin-bottom: 20px;\n}\n\n.signup-form label {\n    display: block;\n    color: #333333; /* Dark text color for labels */\n    margin-bottom: 8px;\n    font-size: 14px;\n}\n\n.signup-form input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ccc; /* Light border for input fields */\n    border-radius: 5px;\n    background-color: #f9f9f9; /* Light background for input fields */\n    color: #333333; /* Dark text color for input fields */\n    font-size: 14px;\n    transition: border-color 0.3s ease;\n}\n\n.signup-form input:focus {\n    outline: none;\n    border-color: #007bff; /* Border color on focus */\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.signup-button {\n    margin-top: 50px;\n    width: 100%;\n    padding: 12px;\n    background-color: #007bff; /* Button color */\n    color: #FFFFFF; /* White text color for button */\n    border: none;\n    border-radius: 5px;\n    font-size: 16px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.signup-button:hover {\n    background-color: #0056b3; /* Darker button color on hover */\n}\n\n.signup-button:disabled {\n    background-color: #004085; /* Disabled button color */\n    cursor: not-allowed;\n}\n\n.error {\n    color: #dc3545; /* Error message color */\n    font-size: 14px;\n    margin-bottom: 15px;\n    text-align: center;\n}\n\n.auth-switch {\n    text-align: center;\n    margin-top: 20px;\n    color: #333333; /* Dark text color for switch link */\n}\n\n.auth-switch span {\n    color: #007bff; /* Link color */\n    cursor: pointer;\n    margin-left: 5px;\n    text-decoration: underline;\n}\n\n.auth-switch span:hover {\n    color: #0056b3; /* Darker link color on hover */\n}\n\n/* Responsive Design */\n@media (max-width: 480px) {\n    .signup-container {\n        padding: 25px;\n    }\n    \n    .signup-container h2 {\n        font-size: 22px;\n    }\n    \n    .signup-form input {\n        padding: 10px;\n    }\n    \n    .signup-button {\n        padding: 10px;\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
